module.exports = __webpack_public_path__ + "2c18000badaff5dbc3ea3b7e4fa2f8f3.mp4";